export const DATE_PATTERNS = new Map([
  ['custom', 'yyyy-MM-ddTkk:mm:ss'],
  ['dashed', 'dd-MM-yyyy'],
  ['day-and-month', 'dd/MM'],
  ['forward-slash', 'dd/MM/yyyy'],
  ['forward-slash-short-year', 'dd/MM/yy'],
  ['full', `dd 'de' MMMM 'de' yyyy`],
  ['full-with-minutes', 'dd/MM/yyyy HH:mm'],
  ['inverse-dashed', 'yyyy-MM-dd'],
  ['inverse-dashed-with-time', `yyyy-MM-dd'T'HH:mm:ss`],
  ['timestamp', `yyyy-MM-dd'T'HH:mm:ssxxx`],
  ['iso-string', 'yyyy-M-dd'],
  ['month-and-year', 'LLLL/yyyy'],
  ['year-and-month', 'yyyy-MM'],
  ['month-and-year', 'MMMM-yyyy'],
  ['short-month-and-year', 'MMM/yyyy'],
  ['month-name', 'MMMM'],
  ['month-number', 'L'],
  ['short-day', 'EEE'],
  ['long-day', 'EEEE'],
  ['time', 'HH:mm'],
  ['year-number', 'yyyy'],
]);
